var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#ffd6d6;}.cls-3{fill:#ce0000;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.57,
    y: 43.58,
    width: 43.86,
    height: 43.86
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    className: "cls-2",
    cx: 65,
    cy: 65,
    r: 65
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1368",
    "data-name": "Group 1368"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    className: "cls-3",
    cx: 64.5,
    cy: 65.5,
    r: 51.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1373",
    "data-name": "Group 1373"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1372",
    "data-name": "Group 1372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46676",
    "data-name": "Path 46676",
    className: "cls-5",
    d: "M84.65,77.07a6.07,6.07,0,0,1-8.58,8.59L64.5,74.08,52.93,85.66a6.08,6.08,0,0,1-8.59,0h0a6.08,6.08,0,0,1,0-8.59h0L55.92,65.5,44.34,53.93a6.07,6.07,0,0,1,0-8.58h0a6.08,6.08,0,0,1,8.59,0h0L64.5,56.92,76.07,45.35a6.07,6.07,0,0,1,8.58,0h0a6.07,6.07,0,0,1,0,8.58h0L73.08,65.5Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.4d189169dce18eec7977aa441d316e35.svg";
export { ForwardRef as ReactComponent };